import { render, staticRenderFns } from "./SelectIngredients.vue?vue&type=template&id=4f344c94&scoped=true&"
import script from "./SelectIngredients.vue?vue&type=script&lang=js&"
export * from "./SelectIngredients.vue?vue&type=script&lang=js&"
import style0 from "./SelectIngredients.vue?vue&type=style&index=0&id=4f344c94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f344c94",
  null
  
)

export default component.exports